import type { LocationIdentifier } from "~/types/api";
import { useLocalStorage } from "@vueuse/core";

export default () => {
  const currentLocationId = useLocalStorage<LocationIdentifier | undefined>("api_location_id", undefined);

  const forgetLocation = async () => {
    const { removeLocationToken } = await useOAuth();

    removeLocationToken();

    currentLocationId.value = null;
  };

  const switchLocation = async (locationId: LocationIdentifier, toPath?: string): Promise<void> => {
    if (currentLocationId.value !== locationId) {
      currentLocationId.value = locationId;
    }

    const { retrieveLocationToken } = await useOAuth();

    await retrieveLocationToken(locationId);

    if (toPath) {
      reloadNuxtApp({
        path: toPath,
        ttl: 0,
        persistState: true,
      });
    }
  };

  return {
    currentLocationId,
    switchLocation,
    forgetLocation,
  };
};
